<template>
  <div v-if="showMenu" class="sidebar__action-wrapper">
    <v-btn :ripple="false" class="sidebar__action" dark icon>
      <v-icon>
        mdi-plus
      </v-icon>
    </v-btn>

    <div class="sidebar__action-menu">
      <span v-for="(item, index) in menuItems" :key="index">
        <span v-if="shouldShowForThisCountry(item)">
          <span @click="item.action" class="sidebar__submenu-link">
            <span class="d-flex align-center text-truncate">
              <v-icon class="sidebar__submenu-icons" left>
                {{ item.icon }}
              </v-icon>
              <span class="body-1 font-weight-medium">
                {{ item.title }}
              </span>
            </span>
          </span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SidebarActionMenu',

  data() {
    return {
      menuItems: [
        {
          icon: 'mdi-calendar-month-outline',
          action: () => this.openCreateAppointmentModal(),
          title: this.$t('create.actionMenu.appointment'),
          showForTheseCountries: ['BR', 'AU',],
        },
        {
          icon: 'mdi-home-city-outline',
          action: () => this.openCreateRealtyModal(),
          title: this.$t('create.actionMenu.realty'),
          showForTheseCountries: ['BR', 'AU',],
        },
        {
          icon: 'mdi-credit-card-sync-outline',
          action: () => this.openRechargeModal(),
          title: this.$t('create.actionMenu.recharge'),
          showForTheseCountries: ['BR'],
        },
        {
          icon: 'mdi-card-account-details-outline',
          action: () => this.openCreateRealEstateUser(),
          title: this.$t('create.actionMenu.newUser'),
          showForTheseCountries: ['BR', 'AU',],
        },
      ],
    }
  },

  computed: {
    ...mapGetters(['user']),

    showMenu() {
      const userRoles = localStorage.getItem('access_roles')
      if (!userRoles) return

      const roles = userRoles?.split(',')
      return roles.includes('ROLE_REAL_ESTATE')
    },

    userCountry() {
      return localStorage.getItem('user_country')
    },
  },

  methods: {
    ...mapActions(['handleOpenRealEstateUserModal']),

    openCreateAppointmentModal() {
      const modal = this.$root.$children[0].$refs?.createAppointmentModal?.$refs?.createModal
      modal.dialog = true
    },

    openCreateRealtyModal() {
      const modal = this.$root.$children[0].$refs?.createUpdateRealtyModal?.$refs?.createRealtyModalWrapper
      modal.dialog = true
    },

    openRechargeModal() {
      const modal =  this.$root.$children[0].$refs?.createRecharge?.$refs?.createModal
      modal.dialog = true
    },

    openCreateRealEstateUser() {
      this.handleOpenRealEstateUserModal()
    },

    shouldShowForThisCountry(item) {
      return item.showForTheseCountries.includes(this.userCountry)
    },
  }
}
</script>
